export class Panel {
  nextElement() {
    const nextElement = getNextSiblingMatching(
      this.currentElement,
      '.listing-element.canPreview',
    );
    if (!nextElement) {
      return;
    }

    this.setElement(nextElement);
  }

  previousElement() {
    const previousElement = getPreviousSiblingMatching(
      this.currentElement,
      '.listing-element.canPreview',
    );
    if (!previousElement) {
      return;
    }

    this.setElement(previousElement);
  }

  setElement(element) {
    this.currentElement = element;
  }

  checkDetailsActions() {
    // On regarde si l'élément courant a un élément qui le précède et s'il en a un qui le suit
    document
      .querySelector(
        '.search-results-preview [data-action="search-result-details:next"]',
      )
      .toggleAttribute(
        'disabled',
        !getNextSiblingMatching(
          this.currentElement,
          '.listing-element.canPreview',
        ),
      );

    document
      .querySelector(
        '.search-results-preview [data-action="search-result-details:previous"]',
      )
      .toggleAttribute(
        'disabled',
        !getPreviousSiblingMatching(
          this.currentElement,
          '.listing-element.canPreview',
        ),
      );
  }
}

function getNextSiblingMatching(element, querySelector) {
  if (!element) return null;

  while ((element = element.nextSibling)) {
    if (element.nodeType === 3)
      // text node
      continue;
    if (element.matches(querySelector)) return element;
  }
  return null;
}

function getPreviousSiblingMatching(element, querySelector) {
  if (!element) return null;

  while ((element = element.previousSibling)) {
    if (element.nodeType === 3)
      // text node
      continue;

    if (element.matches(querySelector)) return element;
  }
  return null;
}
